import TableCellEmpty from "ds/components/Table/Row/CellEmpty";
import TableSimpleCell from "ds/components/TableSimple/Cell";
import { TableSimpleCellProps } from "ds/components/TableSimple/types";

import { ModulePullRequestsTableChildRow } from "../types";

const ModulePullRequestsTableRunEmptyCell = (
  cellProps: TableSimpleCellProps<ModulePullRequestsTableChildRow>
) => {
  return (
    <TableSimpleCell {...cellProps}>
      <TableCellEmpty />
    </TableSimpleCell>
  );
};

export default ModulePullRequestsTableRunEmptyCell;
